import { useContext, useEffect, useState } from "react";
import { useWebinarPageContext } from "../..";
import { SpeakerContext } from "../../../../contexts/SpeakerContext";
import DetailManager from "../../../../Managers/Details";
import TabComponent from "../../../../components/TabsComponent";
import SpeakersCards from "../../../../components/VideoDetails/partials/SpeakersCards";
import Agenda from "../Agenda";
import Details from "../Details";
import Networking from "../Networking/Networking";
import Resources from "../Resources";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import { WEBINAR_TABS_CLICK } from "../../../../AppConstants/AnalyticsEventName";
import { Webinar_status } from "../../../../AppConstants/TypeConstants";
import ScoreManager from "../../../../Managers/ScoringManager/post";
import FeaturedVideos from "../FeaturedVideos";
import styles from "./index.module.scss";
import { SUB_TAB_CLICK_EVENT } from "../../../../Clevertap/EventNames.ts";
import {
  getSubtabData,
  getWebinarClickData,
} from "../../../../Clevertap/EventHandler.ts";
import { isHtmlContentEmpty, scrollTarget } from "../../../../utils/common.utils";

function WebinarTabs({setShowTabDirectly=()=>{}}) {
  const { getMultipleSpeakersData } = useContext(SpeakerContext);
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const { user } = useContext(UserContext);
  const [allSpeakers, setAllSpeakers] = useState([]);
  const [details, setDetails] = useState({ content: "" });
  const { webinarID, state, dispatch } = useWebinarPageContext();

  useEffect(() => {
    if (state.baseInfo) {
      getSpeakers(state.baseInfo.speakers);
      getDetailById();
    }
  }, [state.baseInfo]);

  const getSpeakers = (speakerArray) => {
    let res = getMultipleSpeakersData(speakerArray);
    res.then((array) => setAllSpeakers(array));
  };

  const getDetailById = async () => {
    if (state.baseInfo.detailsId) {
      let res = await DetailManager._get.getDetailById(
        state.baseInfo.detailsId
      );
      if (res) {
        setDetails(res);
      }
    }
  };

  const WEBINAR_TABS = [
    {
      label: "Agenda",
      hideTab: state.baseInfo
        ? state.baseInfo.status === Webinar_status.ENDED
        : false,
      childComponent: () => {
        return <Agenda />;
      },
    },
    {
      label: "Polls",
      hideTab: state.baseInfo
    ? state.baseInfo.status !== Webinar_status.ONGOING
    : false,
      childComponent: () => {
        return <></>;
      },
    },
    {
      label: "Speakers",
      hideTab: !allSpeakers || allSpeakers.length <= 0,
      childComponent: () => {
        return <SpeakersCards speakersList={allSpeakers} />;
      },
    },
    {
      label: "Details",
      hideTab: isHtmlContentEmpty(details?.content),
      childComponent: () => {
        return <Details details={details} />;
      },
    },
    {
      label: "Resources",
      hideTab:
        !state?.baseInfo?.resources || !state?.baseInfo?.resources.length,
      childComponent: () => {
        return (
          <Resources
            eventdata={getWebinarClickData(state.baseInfo)}
            resources={state?.baseInfo?.resources}
          />
        );
      },
    },
    {
      label: "Networking",
      hideTab: state.baseInfo
        ? state.baseInfo.status !== Webinar_status.ONGOING || !user
        : false,

      childComponent: () => {
        return <Networking webinarID={webinarID} />;
      },
    },
    {
      label: "Featured",
      hideTab: !state.baseInfo?.featured || !state.baseInfo?.featured?.length,
      childComponent: () => {
        return <FeaturedVideos baseInfo={state.baseInfo} />;
      },
    },
  ];
  return (
    <div>
      {state.baseInfo && (
        <TabComponent
          onChangeTab={(index) => {
            addGAWithUserInfo(WEBINAR_TABS_CLICK, {
              label: WEBINAR_TABS[index].label,
            });
            addCleverTapAnalytics(
              SUB_TAB_CLICK_EVENT,
              getSubtabData({
                Section: WEBINAR_TABS[index].label,
                ...state.baseInfo,
              })
            );
            if (WEBINAR_TABS[index].label === "Networking") {
              ScoreManager.pointsOnShare(user.uid);
            }else if(WEBINAR_TABS[index].label === "Polls"){
              setShowTabDirectly(WEBINAR_TABS[index].label)
              scrollTarget("#pageData");
            }
          }}
          customHeaderClass={styles.customHeader}
          tabs={WEBINAR_TABS}
          activeTab={state.baseInfo.status === Webinar_status.ENDED ? 1 : 0}
          tabFontSize={"2.1rem"}
          nonActiveClickableTabs={"Polls"}
        />
      )}
    </div>
  );
}

export default WebinarTabs;
